<template>
  <Window
    title="Email"
    window-name="email"
    :icon-src="require('@/assets/task-bar-icons/icon-email.svg')"
    class="email-window"
  >
    <div class="container">
      <ULADialog :visible="showULADialog" @accept="onULAAccept" />
      <EmailSidebar :emails="emails" @itemClick="onItemClick" />
      <EmailContent
        :sender="selectedEmail.sender"
        :subject="selectedEmail.subject"
        :body="selectedEmail.body"
        :html="selectedEmail.html"
        :gameStateKey="selectedEmail.stateKey"
        @firstDayAccept="onFirstDayAccept"
        v-if="selectedEmail"
      />
    </div>
  </Window>
</template>

<script>
import "core-js/features/string/replace-all";
import Window from "@/components/shared/Window";
import ULADialog from "./ULADialog";
import EmailSidebar from "./EmailSidebar";
import EmailContent from "./EmailContent";
import gameStateKeys from "@/assets/gameStateKeys";
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "EmailWindow",
  components: { Window, EmailSidebar, EmailContent, ULADialog },
  data() {
    return {
      emailData: undefined,
      selectedId: undefined,
      showULADialog: false,
      ULAsigned: gameStateStore.stateKey !== gameStateKeys[0],
    };
  },
  methods: {
    onItemClick(emailId) {
      this.selectedId = emailId;
    },
    onFirstDayAccept() {
      if (!this.ULAsigned) this.showULADialog = true;
    },
    onULAAccept() {
      this.showULADialog = false;
      this.ULAsigned = true;
      gameStateStore.jobAccepted = true;
    },
  },
  computed: {
    emails() {
      if (this.emailData) {
        let emails = [];

        for (const stateKey of gameStateKeys) {
          emails = emails.concat(
            this.emailData[stateKey].map(email => ({
              ...email,
              subject: email.subject.replaceAll(
                "{{name}}",
                gameStateStore.username
              ),
              body: email.body.replaceAll("{{name}}", gameStateStore.username),
              read: stateKey !== this.gameStateKey,
              stateKey: stateKey,
            }))
          );

          if (stateKey === this.gameStateKey) break;
        }

        emails = emails.reverse();

        return emails;
      }
      return undefined;
    },
    selectedEmail() {
      if (this.emails && this.selectedId)
        return this.emails.find(({ id }) => id === this.selectedId);
      return undefined;
    },
    gameStateKey() {
      return gameStateStore.stateKey;
    },
  },
  async mounted() {
    const emailJsons = await Promise.all(
      (
        await Promise.all(
          gameStateKeys.map(key =>
            Promise.all([
              fetch(`/game-content/${key}/email/main.json`),
              Promise.resolve(key),
            ])
          )
        )
      )
        .filter(([response]) => response.ok)
        .map(([response, key]) =>
          Promise.all([response.json(), Promise.resolve(key)])
        )
    );

    this.emailData = {};

    emailJsons.map(([value, key]) => {
      this.emailData[key] = value;
    });
  },
};
</script>

<style scoped lang="scss">
.email-window .container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  height: 100%;

  position: relative;
}
</style>
